import {AccountType} from '../../components/Search/SearchNav/types';
import {useViewer} from '../../state/viewer/hooks';

export function useGetIsAcademicUser() {
  const viewer = useViewer();
  const userInfo = viewer?.userInfo;
  return userInfo?.wandbUsageType === AccountType.Academic;
}

export function useGetTrialPlanName() {
  const isAcademicUser = useGetIsAcademicUser();
  return isAcademicUser ? 'Academic' : 'Pro';
}
